module.exports = __webpack_public_path__ + "static/media/course.079acc52.jpg";